import { useEffect, useId, useState } from "react";
import { suggestAddresses, type PlaceSuggestion } from "../lib/places";

type Props = {
  value: string;
  onChange: (next: { address: string; placeId: string }) => void;
};

export function AddressField({ value, onChange }: Props) {
  const listId = useId();
  const [query, setQuery] = useState(value);
  const [hits, setHits] = useState<PlaceSuggestion[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 3) {
      setHits([]);
      return;
    }
    const id = window.setTimeout(() => {
      void suggestAddresses(q).then((rows) => {
        setHits(rows);
        setOpen(rows.length > 0);
      });
    }, 220);
    return () => window.clearTimeout(id);
  }, [query]);

  return (
    <div className="address">
      <label className="field wide">
        <span>Property address</span>
        <input
          role="combobox"
          aria-expanded={open}
          aria-controls={listId}
          autoComplete="off"
          placeholder="Start typing the street"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            onChange({ address: e.target.value, placeId: "" });
          }}
          onFocus={() => setOpen(hits.length > 0)}
          onBlur={() => window.setTimeout(() => setOpen(false), 120)}
        />
      </label>
      {open ? (
        <ul id={listId} className="address-list" role="listbox">
          {hits.map((hit) => (
            <li key={hit.placeId || hit.text}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  setQuery(hit.text);
                  onChange({ address: hit.text, placeId: hit.placeId });
                  setOpen(false);
                }}
              >
                {hit.text}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}